import { useEffect, useState } from "react";
import { applyTimeZone } from "../../../utils/utils";
import Popup from "../../other/Popup";

const idToName = {
    'multiple-choice': 'Selecció múltiple',
    checkbox: 'Vàries opcions',
    'short-answer': 'Resposta curta',
    paragraph: 'Paràgraf',
    'image-upload': 'Pujar imatge',
    'copiable-text': 'Text copiable',
    image: 'Imatge',
    'resum-pagaments': 'Resum pagaments',
    ticket: 'Pagament',
    'ticket-v2': 'Pagament amb quantitats',
    'ticket-v2-single': 'Pagament d\'una quantitat',
    assistance: 'Assistència',
    text: 'Text',
}

function ElementInfo({ element, inputId, idsToDuplicate, setIdsToDuplicate }) {
    const question = element.type !== 'text' ? element.content.question : element.content

    return (
        <div style={{ display: 'flex', margin: '10px 0', alignItems: 'center' }}>
            <input
                id={inputId}
                type="checkbox"
                checked={idsToDuplicate.includes(element.id)}
                onChange={() => {
                    setIdsToDuplicate(currentIds => (
                        currentIds.includes(element.id)
                            ? currentIds.filter(id => id !== element.id)
                            : [...currentIds, element.id]
                    ))
                }}
            />
            <label htmlFor={inputId} style={{ display: 'flex', alignItems: 'center', color: 'grey', fontSize: '14px', cursor: 'pointer', gap: 5 }}>
                { question && <div style={{ cursor: 'pointer' }}>{question}</div> }
                <div style={{ padding: '2px 4px', fontSize: 10, backgroundColor: '#6495ED', color: 'white', borderRadius: 5 }}>{idToName[element.type]}</div>
            </label>
        </div>
    )
}

function FormInfo({ ev, form, handleClick, idsToDuplicate, setIdsToDuplicate}) {
    const orderedElements = [...form.elements].sort((a, b) => {
        const aIndex = form.order.indexOf(a.id)
        const bIndex = form.order.indexOf(b.id)

        if (aIndex === -1 && bIndex === -1) return 0
        if (aIndex === -1) return 1
        if (bIndex === -1) return -1
        return aIndex - bIndex
    })

    return (
        <div
            style={{ padding: '20px', borderBottom: '1px solid #ccc' }}
        >
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: 10 }}>
                <div>
                    <input
                        id={`duplicate-all-${ev.id}`}
                        type="checkbox"
                        checked={form.elements.length > 0 && form.elements.every(el => idsToDuplicate.includes(el.id))}
                        disabled={form.elements.length === 0}
                        style={{ transform: 'scale(1.25)' }}
                        onChange={() => {
                            setIdsToDuplicate(currentIds => (
                                form.elements.every(el => currentIds.includes(el.id))
                                    ? []
                                    : [...new Set(form.elements.map(el => el.id))]
                            ))
                        }}
                    />
                </div>
                <label htmlFor={`duplicate-all-${ev.id}`} style={{ cursor: 'pointer' }}>
                    <h3 style={{ color: '#333', marginBottom: '5px' }}>
                        {
                            (form.title && ev.title) ? `${form.title} (${ev.title})` :
                            (form.title || ev.title)
                        }
                    </h3>
                    <p style={{ color: '#666', fontSize: '12px' }}>{applyTimeZone(ev?.['data-esperada-inici']).format('DD/MM/YYYY HH:mm')}</p>
                </label>
            </div>

            <div
                style={{
                    marginLeft: '30px',
                }}
            >
                {
                    orderedElements.map((el, index) => (
                        <ElementInfo
                            key={`${el.id}-${index}`}
                            element={el}
                            inputId={`duplicate-question-${ev.id}-${el.id}-${index}`}
                            idsToDuplicate={idsToDuplicate}
                            setIdsToDuplicate={setIdsToDuplicate}
                        />
                    ))
                }
            </div>

            {form.elements.length > 0 && idsToDuplicate.some(id => form.elements.map(el => el.id).includes(id)) && (
                <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '20px' }}>
                    <button onClick={() => handleClick(ev.id)} style={{ cursor: 'pointer', padding: '10px 25px' }}>
                        Importar preguntes
                    </button>
                </div>
            )}
        </div>
    )
}

function PopupFormDuplicate({ closed, setClosed, forms, events, duplicateForm, selectedEvent }) {
    const [idsToDuplicate, setIdsToDuplicate] = useState({})
    const [showMore, setShowMore] = useState(10)

    useEffect(() => {
        if (closed) {
            setIdsToDuplicate({})
        }
    }, [closed])

    const eventsWithForms = events
        .filter(ev => ev.id !== selectedEvent)
        .filter(ev => ev.id in forms)

    const handleClick = (evId) => {
        duplicateForm(evId, idsToDuplicate[evId] || [])
        setClosed(true)
    }

    return (
        <Popup
            closed={closed}
            setClosed={setClosed}
        >
            {
                eventsWithForms
                    .sort((a, b) => applyTimeZone(b['data-esperada-inici']).diff(applyTimeZone(a['data-esperada-inici'])))
                    .slice(0, showMore)
                    .map(ev => (
                        <FormInfo
                            key={ev.id}
                            ev={ev}
                            form={forms[ev.id]}
                            handleClick={handleClick}
                            idsToDuplicate={idsToDuplicate[ev.id] || []}
                            setIdsToDuplicate={update => setIdsToDuplicate(currentSelections => {
                                const currentIds = currentSelections[ev.id] || []
                                const nextIds = typeof update === 'function' ? update(currentIds) : update

                                return { ...currentSelections, [ev.id]: nextIds }
                            })}
                        />
                    ))
            }

            {eventsWithForms.length > showMore && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <button onClick={() => setShowMore(showMore + 10)} style={{ cursor: 'pointer', padding: '10px 25px' }}>
                        Mostrar més
                    </button>
                </div>
            )}
        </Popup>
    )
}

export default PopupFormDuplicate;
